export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 0_01.ad8fb346.jpg";